export const serializeClientError = (error: unknown) => {
  const value = error as any;
  return {
    name: value?.name || "Error",
    message: String(value?.message || error || "Unknown error").slice(0, 300),
    code: value?.code ?? null,
    status: value?.response?.status ?? value?.status ?? null,
  };
};

export const getScheduleVisitTrace = (visit: any, error?: unknown) => {
  const visitId = visit?._id ?? visit?.extendedProps?._id ?? null;
  const origin = visit?.origin ?? visit?.extendedProps?.origin;
  const rootVisitId =
    typeof origin === "string" ? origin : (origin?._id ?? visitId);

  return {
    event: "schedule_visit.rrule_parse_failed",
    visitId,
    rootVisitId,
    error: serializeClientError(error),
  };
};
